import { useFieldError } from '~/components/FormContext'

type InputProps = {
  name: string
  label: string
  disabled?: boolean
  value?: string
}

export const Input = ({ name, label, disabled = false, value }: InputProps) => {
  const error = useFieldError(name)

  return (
    <div className="mb-5 mr-4 w-full sm:w-2/5 xl:w-[48%] print:mb-2 print:w-[44%]">
      <label htmlFor={name} className="block">
        <span className="text-gray-700">{label}</span>
        <input
          id={name}
          name={name}
          type="text"
          defaultValue={value}
          disabled={disabled}
          className="mt-1 block w-full rounded disabled:bg-gray-100 print:p-2 print:text-sm"
          placeholder={label}
        />
      </label>
      {error && <p className="font-bold text-red-900">{error}</p>}
    </div>
  )
}
